import React from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';

import Input from '@kyruus/input';
import SearchIcon from '@kyruus/react-ikons/Search';
import CancelIcon from '@kyruus/react-ikons/Cancel';

import {
  SearchInputContainer,
  SearchIconWrapper,
  CancelButton
} from './styles';

import messages from '../../lib/messages';

interface SearchInputProps extends WrappedComponentProps {
  value: string;
  showClearIcon?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onClearIconClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const SearchInput = ({
  value,
  showClearIcon = false,
  onChange,
  onClearIconClick,
  intl
}: SearchInputProps): React.ReactElement => {
  const inputLabel = intl.formatMessage(messages.reviewsSearchInputPlaceholder);
  return (
    <SearchInputContainer>
      <Input
        aria-label={inputLabel}
        hideLabel={true}
        label={inputLabel}
        name="provider-reviews-search-input"
        id="provider-profile-reviews-search-input"
        value={value}
        onChange={onChange}
        data-testid="search-input"
      />
      {value.length === 0 && (
        <SearchIconWrapper
          className="reviews-search-icon-container"
          aria-hidden="true"
        >
          <SearchIcon className="reviews-search-icon" />
        </SearchIconWrapper>
      )}
      {value.length > 0 && showClearIcon && onClearIconClick && (
        <CancelButton
          onClick={onClearIconClick}
          aria-label={intl.formatMessage(
            messages.reviewsSearchInputClearButton
          )}
        >
          <CancelIcon />
        </CancelButton>
      )}
    </SearchInputContainer>
  );
};

export default injectIntl(SearchInput);
